import React from "react";

// Dentist photo when uploaded, otherwise initials on the dentist's calendar colour.
const DentistAvatar = ({ dentist, size }) => (
  <span
    className={`avatar ${size === "lg" ? "avatar--lg" : ""} ${dentist.photoUrl ? "avatar--photo" : ""}`}
    style={dentist.photoUrl ? undefined : { background: dentist.color, color: "#fff" }}
  >
    {dentist.photoUrl ? <img src={dentist.photoUrl} alt="" /> : dentist.initials}
  </span>
);

export default DentistAvatar;
